module.exports = __webpack_public_path__ + "static/media/critical_strike.86c05bd9.png";